// Leaf names can repeat across roots; the first name stays bare because it is the one a list cell shows.
export const qualifyLeafNames = (
    entries: { id: string; name: string; rootName: string }[],
    multipleRoots: boolean
): { id: string; name: string }[] =>
    entries.map(({ id, name, rootName }, index) => ({
        id,
        name: multipleRoots && index > 0 ? `${name} (${rootName})` : name,
    }));
